import { NetworkErrorSvg } from '@/assets/svg/icons/error';
import SentryService from '@/entities/SentryService';
import { Flex } from 'antd';
import React, { ErrorInfo, PropsWithChildren } from 'react';
import ReactGA from 'react-ga';
import './index.less';
type ErrorBoundaryState = {
  error: Error | null;
};

export default class ErrorBoundary extends React.Component<PropsWithChildren<unknown>, ErrorBoundaryState> {
  constructor(props: PropsWithChildren<unknown>) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error('ErrorBoundary:componentDidCatch', error, errorInfo);
    ReactGA.exception({
      description: error.toString() + errorInfo.toString(),
      fatal: true,
    });
    SentryService.captureException(error, { name: 'ErrorBoundary:componentDidCatch', errorInfo });
  }

  render(): string | number | boolean | JSX.Element | React.ReactFragment | null | undefined {
    const { error } = this.state;
    if (error !== null) {
      return (
        <Flex vertical justify="center" className="syn-network-error-wrap">
          <Flex className="syn-network-error" gap={24} vertical align="center">
            <NetworkErrorSvg />
            <Flex gap={8} vertical align="center">
              <span className="sentence1">Network Anomaly</span>
              <span className="sentence2">Something went wrong, please refresh the page.</span>
              {error && <span className="sentence2">Error Detail: {error?.message}</span>}
            </Flex>
          </Flex>
        </Flex>
      );
    }
    return this.props.children;
  }
}
